import { useSyncExternalStore } from 'react';
import { sessionSnapshot, subscribeSession, type SessionSnapshot } from './session.js';

/**
 * Sessão como fonte externa de estado.
 *
 * `useSyncExternalStore` é a ferramenta certa aqui, e não `useState` +
 * `useEffect`: ela garante que o componente leia o valor atual na primeira
 * renderização (sem a janela em que a tela mostra "deslogado" por um frame) e
 * que a comparação de mudança use a referência do snapshot — que agora é nova
 * a cada publicação.
 */
export function useSession(): SessionSnapshot {
  return useSyncExternalStore(subscribeSession, sessionSnapshot, sessionSnapshot);
}
